/**
 数组工具类

 {
   "data":{
     "organizationId":"6011af9c-ebd1-4ed2-bd53-4e93ed30cc1b",
     "wares":{
       "checked":false,
       "id":"2234-2vds-tq236-45yt3-4qw7-yuht-se4w5",
       "code":"Back_Live_SPU",
       "name":"还魂丹",
       "products":0,
       "enable":false,
       "note":null
     },
     "properties":[
       {"code":"MODEL","name":"规格型号","value":"","enable":true,"choose":false},
       {"code":"NUMBER","name":"厂家物料编码","value":"","enable":true,"choose":false},
       {"code":"MANUFACTURER","name":"生产企业","value":"","enable":true,"choose":false},
       {"code":"REGISTER","name":"注册证","value":"","enable":true,"choose":false} ],
     "values":[
       {"REGISTER":"GOD_20190611_500","NUMBER":"Back_Live_500","MODEL":"500年","MANUFACTURER":"太上老君普通炼丹炉"},
       {"REGISTER":"GOD_20190611_800","NUMBER":"Back_Live_500","MODEL":"1000年","MANUFACTURER":"太上老君普通炼丹炉"},
       {"REGISTER":"GOD_20190611_1000","NUMBER":"Back_Live_1000","MODEL":"1000年","MANUFACTURER":"太上老君无上至尊炼丹炉"},
       {"REGISTER":"GOD_20190611_1000","NUMBER":"Back_Live_10000","MODEL":"10000年","MANUFACTURER":"太上老君无上至尊炼丹炉"}]
   }
 }

 =》
  var  showTypes=[
 {"code":"MODEL","name":"规格型号","value":"","enable":true,"choose":false},
 {"code":"NUMBER","name":"厂家物料编码","value":"","enable":true,"choose":false},
 {"code":"MANUFACTURER","name":"生产企业","value":"","enable":true,"choose":false},
 {"code":"REGISTER","name":"注册证","value":"","enable":true,"choose":false} ];

 var showTypeValuesMap={
    "MODEL":[{"value":"500年年","enable":true},{"value":"502年年","enable":true}]，
    "NUMBER":[{"value":"500年年","enable":true},{"value":"502年年","enable":true}]
 }

 var selectMap={
    "MODEL":"500年年"
 }

/**
 * 用于显示用户的值，并可以控制是否允许点击
 */
class SpuPropertyShowValue {
  constructor(code, value, enable) {
    //分类code
    this.code = code
    //显示值
    this.value = value
    //允许点击
    this.enable = enable
  }
}

/**
 * Spu属性选择类
 */
class SpuPropertySelect {
  constructor() {
    //数组Array<object>：用于先分类的数组
    //object={"code":"MODEL","name":"规格型号","value":"","enable":true,"choose":false}
    this.showTypes = null
    //根据分类的code分组values。Map<code,SpuPropertyShowValue>
    this.showTypeValuesMap = null
    //原始数据用于根据条件过滤有效数据，影响：SpuPropertyValue.enable。
    this.values = null
    //选择后的数据
    this.selectMap = {}
  }

  /*
   * @param showTypes
   * @param showTypeValues
   */
  init(showTypes, values) {
    this.showTypes = showTypes
    this.values = values
    this.showTypeValuesMap = this.valuesToShowTypeValuesMap(showTypes, values)
    this.selectMap = this.propertiesToselectMap(showTypes)
  }
  /**
   * *根据分类的code初始化selectMap Map<code,"">
   * 初始化数据，将后台返回数据，初始化selectMap用于表单验证。
   * @param showTypes
   *
   * @return Map<code,"">
   */
  propertiesToselectMap(showTypes) {
    let selectMap = {}
    for (let item of showTypes) {
      selectMap[item.code] = ''
    }
    return selectMap
  }
  /**
     * *根据分类的code分组values。Map<code,SpuPropertyShowValue>
     * 初始化数据，将后台返回数据，转化成前端要求的数据格式。
     * @param showTypes
     * @param values
     *
     * @return Map<code,SpuPropertyShowValue>
     *         *
     *
     *  *     "values":[
     {"REGISTER":"GOD_20190611_500","NUMBER":"Back_Live_500","MODEL":"500年","MANUFACTURER":"太上老君普通炼丹炉"},
     {"REGISTER":"GOD_20190611_800","NUMBER":"Back_Live_500","MODEL":"1000年","MANUFACTURER":"太上老君普通炼丹炉"}]
     =>

     var showTypeValuesMap={
    "MODEL":[{"value":"500年年","enable":true},{"value":"502年年","enable":true}]，
    "NUMBER":[{"value":"500年年","enable":true},{"value":"502年年","enable":true}]
 }
     */

  valuesToShowTypeValuesMap(showTypes, values) {
    var showTypeValuesMap = {}
    for (var value of values) {
      for (var key in value) {
        if (!showTypeValuesMap[key]) showTypeValuesMap[key] = []
        var spuPropertyShowValues = showTypeValuesMap[key]
        //不添加重复数据
        if (this.isRepate(spuPropertyShowValues, value[key])) continue
        var spuPropertyShowValue = new SpuPropertyShowValue(key, value[key], true)
        spuPropertyShowValues.push(spuPropertyShowValue)
      }
    }
    return showTypeValuesMap
  }
  //是否重复数据
  isRepate(spuPropertyShowValues, value) {
    let Repate = false
    for (let spuPropertyShowValue of spuPropertyShowValues) {
      if (spuPropertyShowValue.value === value) {
        Repate = true
      }
    }
    return Repate
  }

  /**
   * 选中数据后，
   * 1.保存选择值到selectMap。
   * 2.触发valuesToShowTypeValuesMap 变化，设置其中属性enable
   * @param key
   * @param value
   */
  selectValue(key, value) {
    this.selectMap[key] = value
    this.updateShowTypeValuesEnable(this.selectMap)
  }

  /**
     * 触发valuesToShowTypeValuesMap 变化，设置其中属性enable
     * 关键步骤：
     * 1.将所有元素的enable清空设置为true。
     * 2.设置已经选中的选项以外的其他选项的可选值，注意，选中了这个选项是不对本选项做约束的。
     * 3.选中的值可能是多个，所以要循环去设置不可选的选项
     * 4.将满足条件的选项设置为false。
     *
     *
     * @param selectMap
     *
     *   var showTypeValuesMap={
    "MODEL":[{"value":"500年年","enable":true},{"value":"502年年","enable":true}]，
    "NUMBER":[{"value":"500年年","enable":true},{"value":"502年年","enable":true}]
 }
     */
  updateShowTypeValuesEnable(selectMap) {
    var showTypeValuesMap = this.showTypeValuesMap
    //初始化，每次点击的时候都要将所有元素的enable清空设置为true。
    for (let key in showTypeValuesMap) {
      let showTypeValues = showTypeValuesMap[key]
      for (let showTypeValue of showTypeValues) {
        showTypeValue.enable = true
      }
    }
    //选中的值可能是多个，循环去设置已经选中的选项以外的其他可选的的选项
    for (let key in showTypeValuesMap) {
      //当这个选项的条件没有选择或者选择的是空值的时候直接跳出本次循环
      if (!selectMap[key]) continue
      //获取符合筛选条件的商品
      let filterValues = this.getFilteringValuesByConditional(selectMap, this.values, key)

      // 每一次都要对其他选项循环遍历去设置不可以选择的值
      for (let showTypeValuesMapKey in showTypeValuesMap) {
        //"MODEL":[{"value":"500年年","enable":true},{"value":"502年年","enable":true}]，
        let showTypeValues = showTypeValuesMap[showTypeValuesMapKey]
        //寻找符合点击后筛选出来的商品，中间变量
        let values = []
        for (let filterValue of filterValues) {
          //将符合筛选条件商品进行遍历，去重添加到一个临时的数组中
          if (values.indexOf(filterValue[showTypeValuesMapKey]) == -1) {
            values.push(filterValue[showTypeValuesMapKey])
          }
        }
        //循环将不符合筛选条件中的选项置灰，
        for (let showTypeValue of showTypeValues) {
          //本次筛选条件对本级选项不做处理
          if (key != showTypeValuesMapKey) {
            if (values.indexOf(showTypeValue.value) == -1) {
              showTypeValue.enable = false
            }
          }
        }
      }
    }
  }

  /**
   * 只返回values满足选择值这个条件的数据
   * @param selectMap
   * @param values
   *
   * @return values
   */
  getFilteringValuesByConditional(selectMap, values, key) {
    let goods = []
    //获取符合筛选条件的商品
    for (let item of values) {
      if (selectMap[key] == item[key]) {
        goods.push(item)
      }
    }
    return goods
  }
}

export default SpuPropertySelect
